export const CAMERA_VENDORS = ["hikvision", "seetong", "hik_vision"] as const;

export type CameraVendor = (typeof CAMERA_VENDORS)[number];

const VENDOR_LABELS: Record<CameraVendor, string> = {
  hikvision: "CP Plus",
  seetong: "Go Lens",
  hik_vision: "Hik Vision",
};

/** Normalize API / form values to a supported camera vendor. */
export function normalizeCameraVendor(value: unknown): CameraVendor {
  const s = String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_");
  if (s === "seetong") return "seetong";
  if (s === "hik_vision" || s === "hik-vision") return "hik_vision";
  return "hikvision";
}

/** UI label for vendor dropdown. */
export function cameraVendorDisplayLabel(vendor: unknown): string {
  return VENDOR_LABELS[normalizeCameraVendor(vendor)];
}

export const CAMERA_VENDOR_OPTIONS = CAMERA_VENDORS.map((value) => ({
  value,
  label: VENDOR_LABELS[value],
}));

/** CP Plus and Hik Vision share the same ONVIF absolute-PTZ stack. */
export function isHikvisionFamilyVendor(vendor: unknown): boolean {
  const normalized = normalizeCameraVendor(vendor);
  return normalized === "hikvision" || normalized === "hik_vision";
}

/** Hikvision-family PTZ uses ONVIF absolute moves (pad, zoom commit, 360° click-to-aim). */
export function usesAbsolutePtzMode(vendor: unknown): boolean {
  return isHikvisionFamilyVendor(vendor);
}

/** Suggested ONVIF HTTP port when picking a camera type in admin. */
export function suggestedOnvifPortForVendor(vendor: unknown): string {
  return normalizeCameraVendor(vendor) === "hik_vision" ? "80" : "80";
}

